import { DialogImagePreview } from './dialog-image/DialogImagePreview';
import { VideoViewer } from './dialog-video/VideoViewer';
import PdfViewer from './dialog-pdf/PdfViewer';
import { fileTypeChecks } from 'utils/file-icon';
import { Box, Stack, Typography } from '@mui/material';
import { IllustrationNoPreview } from '../illustrations/IllustrationNoPreview';

export const DialogFilePreviewContent = ({ file }) => {
  if (fileTypeChecks.isFileImage(file)) {
    return <DialogImagePreview file={file} />;
  }

  if (fileTypeChecks.isFileVideo(file)) {
    return <VideoViewer file={file} />;
  }

  if (fileTypeChecks.isFilePdf(file)) {
    return <PdfViewer file={file} />;
  }

  if (file) {
    return (
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '70%',
          maxHeight: '70%',
          margin: 'auto',
        }}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{ bgcolor: '#ffffff', width: 400, height: 257, borderRadius: 1 }}
        >
          <IllustrationNoPreview />
          <Typography>No preview available</Typography>
        </Stack>
      </Box>
    );
  }
};
